export enum Permission {
  ManageRecipes,
  ViewRecipes,
  ManagePours,
  ViewPours,
  ViewModel,
  ManageStopeData,
  ManageNodeData,
  DeletePours,
  ViewBreakingSchedules,
  MoveBreakingSchedules,
  ViewBinderCostRecords,
  ViewBinderDeliveries,
  // The server's ProjectPermissions.EditProject, e.g. authoring the project's shared dashboard charts.
  EditProject,
}

export const IMPLIED_PERMISSIONS: { [key: number]: Permission[] } = {
  [Permission.ManageStopeData]: [
    Permission.ViewModel,
  ],
  [Permission.ManageRecipes]: [
    Permission.ViewRecipes,
  ],
  [Permission.ManagePours]: [
    Permission.ViewPours,
  ],
};

export enum BackfillPlannerRole {
  MineManager,
  BackfillEngineer,
  NavadaGoldPerson,
  PatersonCooke,
}

const PERMISSIONS = {
  [BackfillPlannerRole.MineManager]: [
    Permission.ManagePours,
    Permission.ViewRecipes,
    Permission.ViewModel,
    Permission.ManageStopeData,
    Permission.ManageNodeData,
    Permission.DeletePours,
    Permission.ViewBreakingSchedules,
    Permission.MoveBreakingSchedules,
    Permission.ViewBinderCostRecords,
    Permission.ViewBinderDeliveries,
  ],
  [BackfillPlannerRole.BackfillEngineer]: [
    Permission.ManagePours,
    Permission.ManageRecipes,
    Permission.ManageStopeData,
    Permission.ManageNodeData,
    Permission.ViewBinderCostRecords,
    Permission.ViewBinderDeliveries,
  ],
  [BackfillPlannerRole.NavadaGoldPerson]: [
    Permission.ManagePours,
    Permission.ManageRecipes,
    Permission.ManageStopeData,
    Permission.ViewRecipes,
    Permission.ViewModel,
    Permission.ViewBreakingSchedules,
    Permission.ViewBinderCostRecords,
    Permission.ViewBinderDeliveries,
  ],
  [BackfillPlannerRole.PatersonCooke]: [
    Permission.ManagePours,
    Permission.ManageRecipes,
    Permission.ManageStopeData,
    Permission.ManageNodeData,
    Permission.ViewRecipes,
    Permission.ViewPours,
    Permission.ViewModel,
    Permission.DeletePours,
    Permission.ViewBreakingSchedules,
    Permission.ViewBinderCostRecords,
    Permission.ViewBinderDeliveries,
    Permission.EditProject,
  ],
};

export const hasPermission = (role: BackfillPlannerRole, permission: Permission) => {
  const impliedPermissions = PERMISSIONS[role].flatMap((p) => IMPLIED_PERMISSIONS[p] ?? []);
  const permissions = [...PERMISSIONS[role], ...impliedPermissions];

  return permissions.includes(permission);
};
